import { useTheme } from "@mui/material";
import { IDotLegalTextFieldWithSnippets } from "./DotLegalTextFieldWithSnippets";
import { createSxStyles } from "../../createSxStyles";

const limitedSnippetsHeight = 177;
const snippetsFadeHeight = 32;

export const useDotLegalTextFieldWithSnippetsStyles = (props: IDotLegalTextFieldWithSnippets) => {
    const theme = useTheme();
    const fadesLimitedSnippets = !!props.hideFrame && !!props.limitHeight;
    let borderColor = props.value || props.disabled || props.disableValidation ? theme.palette.primary.main : theme.palette.error.main;
    return createSxStyles({
        wrapper: {
            marginBottom: props.noMargin ? 0 : theme.spacing(4),
        },
        container: {
            border: props.hideFrame ? "none" : "1px solid " + borderColor,
            borderRadius: 10 + "px",
            marginTop: theme.spacing(1),
        },
        snippets: {
            marginRight: theme.spacing(1),
            marginTop: theme.spacing(1),
        },
        // A fixed height cuts the last visible row of suggestions in half, which reads as broken rather than scrollable.
        // Without the frame, the list fades out at the bottom instead, and the bottom padding lets the last row
        // scroll up clear of the fade.
        snippetScrollArea: {
            maxHeight: fadesLimitedSnippets ? limitedSnippetsHeight : undefined,
            maskImage: fadesLimitedSnippets ? `linear-gradient(to bottom, black calc(100% - ${snippetsFadeHeight}px), transparent)` : undefined,
        },
        snippetContainer: {
            display: "flex",
            flexWrap: "wrap",
            maxHeight: props.limitHeight && !fadesLimitedSnippets ? limitedSnippetsHeight : undefined,
            paddingBottom: fadesLimitedSnippets ? `${snippetsFadeHeight}px` : undefined,
        },
        snippetHeader: {
            marginTop: theme.spacing(1),
            fontWeight: theme.typography.fontWeightBold,
            fontStyle: props.hideFrame ? "normal" : "italic",
            color: theme.palette.primary.dark,
            // Without the frame, a smaller heading is what shows the suggestions belong to the field above.
            fontSize: theme.typography.pxToRem(props.hideFrame ? 12 : 14),
        },
        margin: {
            margin: props.hideFrame ? 0 : theme.spacing(1),
            "& .MuiInputBase-root": {
                padding: theme.spacing(1),
                backgroundColor: theme.customPalette.white,
                borderRadius: theme.shape.borderRadius + "px",
            },
        },
        error: {
            color: theme.palette.error.main,
            fontSize: theme.typography.pxToRem(12),
            marginLeft: theme.spacing(1.5),
            marginTop: theme.spacing(0.5),
        },
    });
};
